// roleService.js
import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class RoleService {
  fetchRoles = (roleId = 0) => {
    return axiosInstance.get(`${BASE_URL}/v1/user/roles/all?roleId=${roleId}`);
  };

  createRole = (roleData) => {
    return axiosInstance.post(`${BASE_URL}/v1/user/role`, roleData);
  };

  updateRole = (roleId, roleData) => {
    return axiosInstance.put(`${BASE_URL}/v1/user/role/${roleId}`, roleData);
  };

  deleteRole = (roleId) => {
    return axiosInstance.delete(`${BASE_URL}/v1/user/role/${roleId}`);
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RoleService();
